module.exports = __webpack_public_path__ + "img/checked.241e7c45.png";